import { FormControl } from '@mui/material';

import { styled } from '../../theme/stitches.config';

export const StyledContainer = styled('div', {
  padding: '16px 0',
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  width: '100%',
});

export const StyledFormControl = styled(FormControl, {
  width: '100%',
});
